import type { ChipDefinition } from '@/types/hid8051';

/**
 * Nuvoton MS51FB9AE — 8051 core, 16 KB APROM, 4 KB LDROM max, 128 B pages
 * Device ID: 0x00DA4B21
 */
export const MS51FB9AE: ChipDefinition = {
  name: 'MS51FB9AE',
  family: 'nuvoton-8051',
  deviceId: 0x00DA4B21,
  flashSize: 16 * 1024,       // 16 KB APROM
  ldromMaxSize: 4 * 1024,     // 4 KB LDROM max
  pageSize: 128,              // 128 byte erase pages
  configSize: 5,              // 5 config bytes
};
